import CouponExpired from './CouponExpired';
import CouponNotFound from './CouponNotFound';

type Props = {
  couponExpired: boolean;
  expiresAt?: null | string;
};

export function InvalidCoupon({ couponExpired, expiresAt }: Props): React.ReactElement {
  if (!expiresAt) {
    return <CouponNotFound />;
  }

  return couponExpired ? <CouponExpired expiresAt={expiresAt} /> : <CouponNotFound />;
}
